import work from '../media/Work.png';

const properties = [
  {
    id: '1',
    img: work,
    jobname: 'Junior Frontend Developer',
    address: 'Hồ Chí Minh City',
    experience: 2,
    peoplerecruit: 2,
    salary: 2000,
  },
  {
    id: '2',
    img: work,
    jobname: 'Senior Backend Developer',
    address: 'Hồ Chí Minh City',
    experience: 0,
    peoplerecruit: 10,
    salary: 'negotiate',
  },
  {
    id: '3',
    img: work,
    jobname: 'Project Manager',
    address: 'Hồ Chí Minh City',
    experience: 5,
    peoplerecruit: 1,
    salary: 10000,
  },
  {
    id: '4',
    img: work,
    jobname: 'Junior Frontend Developer',
    address: 'Hồ Chí Minh City',
    experience: 2,
    peoplerecruit: 2,
    salary: 2000,
  },
  {
    id: '5',
    img: work,
    jobname: 'Senior Backend Developer',
    address: 'Hồ Chí Minh City',
    experience: 0,
    peoplerecruit: 10,
    salary: 'negotiate',
  },
  {
    id: '6',
    img: work,
    jobname: 'Project Manager',
    address: 'Hồ Chí Minh City',
    experience: 5,
    peoplerecruit: 1,
    salary: 10000,
  },
];

export default properties;
